module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0067.jpg?v=aee35032";